import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'
import { FaAngleDown } from 'react-icons/fa'
import ModalFiltro from './ModalFiltro'

import { stMob } from '../styles'

export default function FiltroAvulsos() {
  const { modaisAgend, sttCtxAgend, actionsAgend } = React.useContext(AgendamentoContext)

  return (
    <Box sx={stMob.containButtons}>
      {modaisAgend.tipo && (
        <ModalFiltro
          type='tipo'
          modal={modaisAgend.tipo}
          onClosed={() => {
            actionsAgend.handleModaisAgend('tipo', false)
          }}
        />
      )}
      {modaisAgend.situacao && (
        <ModalFiltro
          type='situacao'
          modal={modaisAgend.situacao}
          onClosed={() => {
            actionsAgend.handleModaisAgend('situacao', false)
          }}
        />
      )}
      <Button sx={stMob.containFiltro} onClick={() => actionsAgend.handleModaisAgend('situacao', true)}>
        <Box sx={stMob.containLabelFiltro}>
          <Typography sx={stMob.titleFiltro}>Situação</Typography>
          <Typography sx={stMob.valueFiltro}>{sttCtxAgend.typePed}</Typography>
        </Box>
        <FaAngleDown style={stMob.iconFiltro} />
      </Button>
      <Button sx={stMob.containFiltro} onClick={() => actionsAgend.handleModaisAgend('tipo', true)}>
        <Box sx={stMob.containLabelFiltro}>
          <Typography sx={stMob.titleFiltro}>Tipo</Typography>
          <Typography sx={stMob.valueFiltro}>{sttCtxAgend.avulsoSel}</Typography>
        </Box>
        <FaAngleDown style={stMob.iconFiltro} />
      </Button>
    </Box>
  )
}
